module.exports = __webpack_public_path__ + "static/Work-dekstop-7ab0b5608670e3ef29368ee200a93c82.jpg";